import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WebapiService } from '../webapi.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ratebookprocess',
  templateUrl: './ratebookprocess.component.html',
  styleUrls: ['./ratebookprocess.component.scss'],
})
export class RatebookprocessComponent implements OnInit {
 @ViewChild('chatContainer') private chatContainer!: ElementRef;
  private controller: AbortController | null = null;

//System Instruction
 prompt: string = `
    Instructions for the AI:
    You are the AI assistant for a Ratebook File Management Tool. Your goal is to identify the user's Intent, manage the conversation flow to collect specific Data, and output your response in strict JSON format.

    Input Context: You will receive:

    Conversation History: Previous questions and answers.
    Current User Input: The latest message from the user.
    Current State: The intent identified so far (if any).

    Supported Intents & Required Data:

    You must map the user's input to one of the following intents. If the intent is unclear, ask a clarifying question.

    1. Intent: Create Event

    Description: The user (admin) wants to activate or create a new event.

    Required Data (Slots) to Collect:

    event_type: Must be normalized to exactly "Active Lane" or "Update Lane".

    Handling Input: 
    If the user says "active", "active lane event", "create active", map it to "Active Lane". 
    If they say "update", "update lane", map it to "Update Lane".

    start_date: The date the event begins (extract as DD-MM-YYYY or ISO format if possible).

    duration_days: The number of days the event will be active (Integer).
    active_lane_file:  its json string in format {filename:"","displayname":""} , filename is for internal use purpose (craeated using uiid), display name is user file name.Ask user to attche filename . on attach it will add  or appned automaticly json string as ans 
    Ask user thease all data at start when we got intent.

    2. Intent: Submit  Ratebook

    Description: Submit the partner ratebook for active lane event or update lane event.

    Required Data (Slots) to Collect:
    event_type : Must be normalized to exactly "Active Lane" or "Update Lane"
    If the user says "active", "active lane event", "create active", map it to "Active Lane". 
    If they say "update", "update lane", map it to "Update Lane".
    The provided event should be active. Providing you active event list.with system instruction. 
    ratebook_file:  its json string in format {filename:"","displayname":""} , filename is for internal use purpose (craeated using unique id on attached), display name is user file name.
    Ask user to attche filename . on attach it will add  or appned automaticly json string as ans.user ans query should be attached with  json format {filename:"","displayname":""}. do not create you own.
    month: month for which ratebook is applicable
    year: year for which ratebook is applicable

    the steps for this are 1) collecting_data 2) complete 


    Ask user thease all data at start when we got intent.

    3. Intent: Download Ratebook

    Download Active Lane Ratebook: Downloading the current ratebook.

    Response Logic:

    Identify Intent: Look at the Current User Input. If an intent is not yet established, determine which of the above intents matches best.

    Validate Data: Check if the user provided any of the Required Data in their initial message.

    Example:
    "I want to create an active lane event starting tomorrow for 10 days."
    -> Intent is Create Event
    -> event_type is "Active Lane"
    -> start_date is [Tomorrow's Date]
    -> duration_days is 10

    Check for Missing Data: 
    If the identified intent requires data that is currently missing, formulate a follow_up_question to ask for one piece of missing info at a time.

    Completion:
    If the Intent is clear and ALL required data points are collected and valid:

    Set "step": "complete"
    Set "follow_up_question": "Thank you, I am processing your request. Please wait."
    Output the collected data in the data object.

    Output Format (Strict JSON Only):

    Do not include markdown formatting (like \`\`\`json). 
    Just return the raw JSON object.

    JSON Structure:
      {
      "intent": "String (The identified intent, e.g., 'Create Event')",
      "step": "String ('identifying_intent', 'collecting_data', or 'complete')",
      "follow_up_question": "String (The question to ask the user, or a closing statement if complete) in html format that i can render directly in [innerHTML]",
      "data": {
        "event_type": "String or null",
        "start_date": "String or null",
        "duration_days": "Integer or null",
        "other_fields": "..."
      }
    }
      
    Active events : [{event_type:'Active Lane',start_on:"12/1/2025",days:15}]
    note : start_on date is in MM/DD/YYYY format
`;

history:any=[]
currentstate=null

  messages:any= [];

  welcome_msg="📈🔎 What you’d like to analyze today"
  isOpen = false;
  userInput = '';
  selectedmodule:any;
  config_list:any=[]
  role:any=""
  botlist:any=[];
  currentAbortController:any=null

  constructor(private router:Router,private service:WebapiService,private sanitizer: DomSanitizer) {
        this.role=localStorage.getItem('role');

   }

  type=""

  scrollToBottom() {
    try {
      setTimeout(() => {

      this.chatContainer.nativeElement.scrollTop =
        this.chatContainer.nativeElement.scrollHeight;
        }, 50);
    } catch (err) {}
  }

  toggleChat() {
    this.isOpen = !this.isOpen;
  }
  
  loadingTimeouts = new Map<number, any>();
  currentChatId: number = 0;


  ngOnInit() {
    // this.getall_botlist();

  }



  ///functions 

  handleDynamicClick(event: Event) {
    const target = event.target as HTMLElement;
 // alert(target.tagName+","+ target.classList.toString())

    if (target.tagName === 'SPAN' && target.classList.contains('btn')) {
        const index = target.getAttribute('data-index');
       // alert(index)
        if (index !== null) {
            this.setmodule(Number(index));

            
        }
    }
 }
private botListAbortController: AbortController | null = null;

flag=false;

setque(text:any)
{
  this.userInput=text;
}

groupHintsByType(hintList: { question: string; type?: string }[]) {
  const groups: any = {};

  hintList.forEach(h => {
    const typeName = h.type && h.type.trim() !== '' ? h.type : 'Others';

    if (!groups[typeName]) {
      groups[typeName] = { open: false, questions: [] };
    }

    groups[typeName].questions.push(h);
  });

  // Convert to sorted object with Others at bottom
  const ordered: any = {};

  Object.keys(groups)
    .filter(k => k !== 'Others')
    .sort()                        // optional alphabetical ordering
    .forEach(k => ordered[k] = groups[k]);

  // Add Others at the end (if exists)
  if (groups['Others']) {
    ordered['Others'] = groups['Others'];
  }

  return ordered;
}

toggleType(type: string) {
  this.hintGroups[type].open = !this.hintGroups[type].open;
}

hintGroups:any=[]

hintList:any=[]

  setmodule(x: number) {
      this.selectedmodule = this.config_list[x];
      console.log(this.selectedmodule)
      this.hintList=JSON.parse(this.selectedmodule.shintquestion);
      this.hintGroups = this.groupHintsByType(this.hintList);

  }

  
  apiTime: string = '';
  apiLiveSeconds: string = '';
  apiResponse: any;
  loading: boolean = false;
  private intervalId: any;

 isValidJSON(str:any) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

// cat function
  activereq:any=null
  selectedtopic:any=""
  hint:any="Enter here.."
  setTopic(topic:any){
  this.selectedtopic=topic;
   if(topic=='Ratebook Submit')
   {
     this.hint="please attach csv formated Ratebook file ,let me know the month and year"
   }
  }
  chat(q: string) {


        this.controller = new AbortController();

    
  
      var cleaned = this.sanitizeUserInput(q);
  
          const thisChatId = ++this.currentChatId;
  
   
    
      this.messages.push({
          msgby: 'user',
          msg: cleaned,
          timestamp: new Date(),
          chatId: thisChatId
      });
    this.apiTime = '';
    this.apiLiveSeconds = '';
    this.loading = true;
      const loadingMessageIndex = this.messages.length;
      this.messages.push({
          msgby: 'bot',
          msg: '⏳ Thinking..',
          apitime:this.apiTime,
          apiLiveSeconds:this.apiLiveSeconds,
          timestamp: new Date(),
          chatId: thisChatId,
          isTemp: true
      });
        

    const start = performance.now();
    const startTime = Date.now();   // For seconds timer

    // Start live seconds counter
        this.intervalId = setInterval(() => {
          const diff = (Date.now() - startTime) / 1000; // seconds
          this.apiLiveSeconds = diff.toFixed(1) + "";
          this.messages[loadingMessageIndex].msg= "⏳ Thinking..("+this.apiLiveSeconds+") sec"; 
        }, 100); // update every 0.1s
      this.scrollToBottom();
  
      
      if(this.selectedFileName!='')
       cleaned=cleaned+', i am attaching the file : {"filename":"'+this.attachment+'","displayname":"'+this.selectedFileName+'"}'

     this.activereq= this.service.postData_cancel({'query': cleaned, 'prompt': this.prompt,history:this.history,'timeout': 180}, 'gemini_resp');
     
     this.activereq.promise .then((result:any) => {
              console.log(result)
              clearTimeout(this.loadingTimeouts.get(thisChatId));
              this.loadingTimeouts.delete(thisChatId);


              var jsonres = JSON.parse(result.json_result);
              var msg=""
              if(jsonres.step=="Complete"||jsonres.step=="complete")
              {
                 msg = jsonres.follow_up_question;
                 console.log(jsonres.data)
                 if(jsonres.intent=="Submit Ratebook")
                 {
                      if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
  
                            if(result.type=='json')
                              {
                                    
                              }
                            //  var res:any=this.extractAndRemoveCharts(this.cleanGoogleChartTag(result.natural_response))
                            //  console.log(res.data);
                            //  console.log(res.cleanedHtml);
                            var jsondata=""
                            msg="Validating your file..please wait"
                            if(this.isValidJSON(result.json_result))
                              jsondata=this.convertJsonToHtml(JSON.parse(result.json_result))
                            this.finishTimer(start);
                            this.messages[loadingMessageIndex] = {
                                msgby: 'bot',
                                msg: msg,
                                code:result.code,
                                mode:result.mode,
                                response:result.response,
                                type:result.type,
                                apiTime:this.apiTime,
                                dflen:result.dflen,
                                download:result.json_data,
                                download_json:jsondata,
                                charts:[],
                                timestamp: new Date(),
                                chatId: thisChatId
                            };
                            console.log(this.messages[loadingMessageIndex]);
                            this.scrollToBottom();
                        }
                         console.log(jsonres)
                         let ratebookFile = jsonres?.data?.ratebook_file;

                          // If it's a string → parse it
                          if (typeof ratebookFile === 'string') {
                            try {
                              ratebookFile = JSON.parse(ratebookFile);
                            } catch (e) {
                              console.error('Invalid JSON string in ratebook_file:', ratebookFile);
                              ratebookFile = null;
                            }
                          }
                           this.service.postData({filename:ratebookFile.filename},"validating_ratebook").then(res=>{
                              if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
  
                                    var ress:any=res;
                                    //  var res:any=this.extractAndRemoveCharts(this.cleanGoogleChartTag(result.natural_response))
                                    //  console.log(res.data);
                                    //  console.log(res.cleanedHtml);

                                    var jsondata=""
                                    if(ress.result==0)
                                    {
                                      msg=ress.error+" Missing cols are "+ ress.missing_columns.toString()
                                    }
                                    else{
                                     msg="Validated your ratebook successfully..running price model"


                                          this.service.postData({chatid:"123",userid:"1",date:"12/1/2025",Exch:1.07,Threshold:50,ftype:2,filename:ratebookFile.filename,displayname:ratebookFile.displayname,filedetails:ratebookFile},"price_modeling_ratebook").then(res=>{

                                              console.log(res)
                                               msg="Completed pricemodel"

                                          });

                                          return;


                                    }
                                    if(this.isValidJSON(result.json_result))
                                      jsondata=this.convertJsonToHtml(JSON.parse(result.json_result  ))
                                    this.finishTimer(start);
                                    this.messages[loadingMessageIndex] = {
                                        msgby: 'bot',
                                        msg: msg,
                                        code:result.code,
                                        mode:result.mode,
                                        response:result.response,
                                        type:result.type,
                                        apiTime:this.apiTime,
                                        dflen:result.dflen,
                                        download:result.json_data,
                                        download_json:jsondata,
                                        charts:[],
                                        timestamp: new Date(),
                                        chatId: thisChatId
                                    };
                                    console.log(this.messages[loadingMessageIndex]);
                                    this.scrollToBottom();
                                }
                       });
                       return;
                 }
              }
              else{

                msg = jsonres.follow_up_question;


              }
   
              this.history.push({
                questions:cleaned,
                answer:result.json_result,
                intent:jsonres.intent
              })
              // console.log(this.cleanGoogleChartTag(result.natural_response));
              if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
  
                   if(result.type=='json')
                     {
                          
                     }
                  //  var res:any=this.extractAndRemoveCharts(this.cleanGoogleChartTag(result.natural_response))
                  //  console.log(res.data);
                  //  console.log(res.cleanedHtml);
                  var jsondata=""
                  if(this.isValidJSON(result.json_result))
                     jsondata=this.convertJsonToHtml(JSON.parse(result.json_result))
                  this.finishTimer(start);
                  this.messages[loadingMessageIndex] = {
                      msgby: 'bot',
                      msg: msg,
                      code:result.code,
                      mode:result.mode,
                      response:result.response,
                      type:result.type,
                      apiTime:this.apiTime,
                      dflen:result.dflen,
                      download:result.json_data,
                      download_json:jsondata,
                      charts:[],
                      timestamp: new Date(),
                      chatId: thisChatId
                  };
                  console.log(this.messages[loadingMessageIndex]);
                  this.scrollToBottom();
              }
                    

          })
          .catch((res:any) => {
              if (res.name === 'AbortError') {
                  console.log('Request was aborted by a new user message or start over.');
                  clearTimeout(this.loadingTimeouts.get(thisChatId));
                  this.loadingTimeouts.delete(thisChatId);
                  return;
              }
              
              console.error('API Error:', res);
              clearTimeout(this.loadingTimeouts.get(thisChatId));
              this.loadingTimeouts.delete(thisChatId);
  
              if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
                  this.messages[loadingMessageIndex] = {
                      msgby: 'bot',
                      msg: 'Oops! Something went wrong. Please try again.',
                      timestamp: new Date(),
                      chatId: thisChatId
                  };
                  this.scrollToBottom();
              }
                this.finishTimer(start);

          })
          .finally(() => {
              this.currentAbortController = null;
          });
  }

  //cancel
cancelRunningApi() {
  if (this.activereq) {
    this.activereq.cancel();
    this.activereq = null;
  }
  // Stop timer if running
  if (this.intervalId) {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  // Optional: show cancel message
  this.messages.push({
    msgby: 'bot',
    msg: '❌ Request cancelled.',
    timestamp: new Date()
  });

  this.loading = false;
}

// file uplaod modeul
selectedFile!: File | null;
attachment:any=""
selectedFileName = '';

onFileSelected(event: any) {
  const file: File = event.target.files[0];
  if (!file) return;

  // ✅ Allow only CSV
  if (!file.name.toLowerCase().endsWith('.csv')) {
    alert('Only CSV files are allowed.');
    return;
  }

  

  this.selectedFile = file;
  this.selectedFileName ="Uploading.."
  console.log(this.selectedFileName,this.selectedtopic!='' , this.selectedFileName!='')
  this.attachment=""
   var form_data = new FormData();  
     
                form_data.append('file', this.selectedFile); 
                form_data.append('chatid',"123" ); 
                form_data.append('userid',"1"); 
                form_data.append('displayname',"Ratebook file" ); 
                form_data.append('filedetails',JSON.stringify({"tag":this.selectedtopic,"filename":this.selectedFileName,"month":"04","year":"2025"})); 

                form_data.append('type',"" ); 
                form_data.append('uby', localStorage.getItem("email")); 

                this.service.postData1(form_data, 'ai_file_uplaod').then((result) => {
                  var temp: any = result;
                 this.selectedFileName = file.name;
                 this.attachment=temp.filename;
                  
            
            }).catch(e => {
                               this.selectedFileName = "failed. plz try again";

            });
          


  // this.pushUser(`Attached file: ${file.name}`);
}

removeFile() {
  this.selectedFile = null;
  this.selectedFileName = '';
}

// timer
  
  finishTimer(start: number) {
  const end = performance.now();
  const totalMs = (end - start).toFixed(2);
  const totalSec = (Number(totalMs) / 1000).toFixed(2);

  this.apiTime = `${totalSec} sec`;

  this.loading = false;

  clearInterval(this.intervalId); // Stop live timer
}



// suuport functions
    sendMessage() {
      console.log(this.userInput)
      if (this.userInput.trim() !== '') {
        // this.messages.push({
        //   msgby: 'user',
        //   msg: this.userInput,
        //   timestamp: new Date()
        // });
  
        this.chat( this.userInput);
        // const botResponse = `You said: ${this.userInput}`;
        // setTimeout(() => {
        //   this.messages.push({
        //     msgby: 'bot',
        //     msg: botResponse,
        //     timestamp: new Da
        // te()
        //   });
        // }, 500);
  
        this.userInput = '';
      }
    }
  
    cleanGoogleChartTag(htmlString: string): string {
    // Regex to find the <google-chart> tag and its data attribute.
    // The 's' flag allows '.' to match newline characters.
    const regex = /(<google-chart\s+\[data\]=")([^"]*)("><\/google-chart>)/s;
  
    // Use the replace method with a replacer function to capture and clean the content.
    return htmlString.replace(regex, (match, p1, p2, p3) => {
      // p1: The opening part of the tag (e.g., "<google-chart [data]=").
      // p2: The raw content of the [data] attribute (the data object string).
      // p3: The closing part of the tag (e.g., "></google-chart>").
  
      // Clean the captured data by replacing all whitespace characters (\s)
      // with an empty string globally (g).
      const cleanedData = p2.replace(/\s+/g, '');
  
      // Reconstruct the tag with the cleaned data and return it.
      return `${p1}${cleanedData}${p3}`;
    });
  
    
  }
  
  
   extractAndRemoveCharts(htmlString:any) {
      const dataArray = [];
      // Regex to find the data attribute content more robustly
      const extractRegex = /<google-chart\s+\[data\]="([^"]*)"[^>]*>/gs;
      let match;
  
      while ((match = extractRegex.exec(htmlString)) !== null) {
          let rawDataString = match[1];
  
          try {
              // Replace known HTML entities and single quotes
              rawDataString = rawDataString.replace(/&quot;/g, '"');
              rawDataString = rawDataString.replace(/'/g, '"');
  
              const chartData = JSON.parse(rawDataString);
              dataArray.push(chartData);
          } catch (e) {
              console.error('Failed to parse JSON data from a <google-chart> tag:', e);
              console.error('Problematic string:', rawDataString);
          }
      }
      
      // Regex to remove the entire <google-chart> tag
      const removeRegex = /<google-chart\s+\[data\]="[^"]*"[^>]*><\/google-chart>/gs;
      const cleanedHtml = htmlString.replace(removeRegex, '').trim();
  
      return {
          data: dataArray,
          cleanedHtml: cleanedHtml,
      };
  }
   sanitizeUserInput(input: string): string {
    if (!input) return "";
  
    // 1. Trim whitespace
    let sanitized = input.trim();
  
    // 2. Remove HTML tags
    sanitized = sanitized.replace(/<[^>]*>/g, "");
  
    // 3. Block suspicious characters often used in injections
    sanitized = sanitized.replace(/[{};$<>]/g, "");
  
    // 4. Limit length (avoid DoS by very large input)
    const MAX_LENGTH = 500;
    if (sanitized.length > MAX_LENGTH) {
      sanitized = sanitized.substring(0, MAX_LENGTH);
    }
  
    return sanitized;
  }
  
  // Validation example
  isValidUserInput(input: string): boolean {
    if (!input) return false;
  
    // Reject empty or too short input
    if (input.trim().length < 2) return false;
  
    // Reject if contains SQL/JS keywords (basic filter)
    const blacklist = /(SELECT|INSERT|DELETE|UPDATE|DROP|SCRIPT|ALERT|ONERROR)/i;
    if (blacklist.test(input)) return false;
  
    return true;
  }
  downloadJSONToCSV(datas: string, filename: string = 'responseresult.csv'): void {
      var data = JSON.parse(datas);
    if (!data || !data.length) {
      console.warn('No data to export');
      return;
    }
  
    // Extract headers from first object
    const headers = Object.keys(data[0]);
  
    // Build CSV rows
    const csvRows: string[] = [];
  
    // Add header row
    csvRows.push(headers.join(','));
  
    // Add data rows
    for (const item of data) {
      const row = headers.map(header => {
        let val = item[header] ?? ''; // handle null/undefined
        val = String(val).replace(/"/g, '""'); // escape double quotes
        return `"${val}"`;
      });
      csvRows.push(row.join(','));
    }
  
    // Create CSV string
    const csvString = csvRows.join('\n');
  
    // Create Blob for download
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
  
    // Create link element and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  isCSVDownloadableFromJSON(jsonString: string): boolean {
    try {
      // 1️⃣ Parse JSON safely
      const data = JSON.parse(jsonString);
  
      // 2️⃣ Must be an array
      if (!Array.isArray(data) || data.length === 0) {
        console.warn("❌ JSON is not a valid non-empty array.");
        return false;
      }
  
      // 3️⃣ Each item must be a plain object
      const isObjectArray = data.every(
        (item) => item && typeof item === "object" && !Array.isArray(item)
      );
      if (!isObjectArray) {
        console.warn("❌ JSON must contain plain objects only.");
        return false;
      }
  
      // 4️⃣ Each object must have at least one key
      const hasKeys = data.every((obj) => Object.keys(obj).length > 0);
      if (!hasKeys) {
        console.warn("❌ Some objects have no properties.");
        return false;
      }
  
      // ✅ All checks passed
      return true;
    } catch (error) {
      console.error("❌ Invalid JSON format:", error);
      return false;
    }
  }

  convertJsonToHtml(data: any): string {

    const styleBlock = `
      <style>
        .json-wrapper {
          height: 200px;
          width: 100%;
          overflow: hidden; /* prevent double scrollbars */
          font-family: Arial, Helvetica, sans-serif;
          font-size: 14px;
        }

        /* Table and fixed header styling */
        .json-table {
          width: 100%;
          border-collapse: collapse;
        }

        .json-table thead {
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 5;
        }

        .json-table th,
        .json-table td {
          border: 1px solid #000;
          padding: 8px;
          white-space: nowrap;
          text-align: left;
          vertical-align: top;
        }

        /* Scrollable body only */
        .json-scroll-body {
          max-height: 200px;
          overflow-y: auto;
          overflow-x: auto;
          display: block;
        }

        /* Force table columns to align in scroll-body */
        .json-scroll-body table {
          width: 100%;
          border-collapse: collapse;
        }

        /* List for primitive arrays */
        .json-list {
          margin: 6px 0 6px 15px;
        }
      </style>
    `;

    return styleBlock + this.generateJsonHtml(data);
  }
  generateJsonHtml(data: any, isRoot: boolean = true): string {

    if (data === null || data === undefined) {
      return "<span>null</span>";
    }

    if (typeof data !== "object") {
      return `<span>${data}</span>`;
    }

    // ARRAY
    if (Array.isArray(data)) {

      // Primitive array → simple list
      if (data.every(x => typeof x !== "object")) {
        const sliced = isRoot ? data.slice(0, 5) : data;

        return `
          ${isRoot ? `
            <div class="json-title">
              Showing Top ${sliced.length} Records (Full list available for download)
            </div>
          ` : ""}

          <ul class="json-list">
            ${sliced.map(i => `<li>${i}</li>`).join("")}
          </ul>
        `;
      }

      // Array of objects → table
      const total = data.length;
      const slicedRows = isRoot ? data.slice(0, 5) : data;
      const headers = Object.keys(slicedRows[0] || {});

      return `
        ${isRoot ? `
          <div class="json-title">
            Showing Top ${slicedRows.length} of ${total} Records (Full list available for download)
          </div>
        ` : ""}

        <div class="json-wrapper">
          <div class="json-scroll-body">
            <table class="json-table">
              <thead>
                <tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr>
              </thead>
              <tbody>
                ${slicedRows.map(row => `
                  <tr>
                    ${headers.map(col => `
                      <td>${this.generateJsonHtml(row[col], false)}</td>
                    `).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </div>
        </div>
      `;
    }

    // OBJECT → table
    return `
      <div class="json-wrapper">
        <div class="json-scroll-body">
          <table class="json-table">
            <thead>
              <tr><th>Key</th><th>Value</th></tr>
            </thead>
            <tbody>
              ${Object.keys(data).map(key => `
                <tr>
                  <th>${key}</th>
                  <td>${this.generateJsonHtml(data[key], false)}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        </div>
      </div>
    `;
  }

  //code copy
  copyCode(code: string) {
  navigator.clipboard.writeText(code.trim());
}
}
